import { createFileRoute } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/admin-shell";
import { CrudManager } from "@/components/admin/crud-manager";

export const Route = createFileRoute("/_authenticated/admin/rollar")({
  component: Page,
});

const ROLE_LABEL: Record<string, string> = {
  admin: "Admin",
  moderator: "Moderator",
  user: "İstifadəçi",
};

function Page() {
  return (
    <div>
      <AdminPageHeader
        title="Admin rolları və icazələr"
        description="İstifadəçi ID-si əsasında rol təyin et. Admin — tam icazə, Moderator — elan və şikayət moderasiyası, İstifadəçi — standart icazə."
      />
      <CrudManager
        table="user_roles"
        addLabel="Yeni rol təyin et"
        emptyText="Rol təyinatı yoxdur."
        fields={[
          { name: "user_id", label: "İstifadəçi ID (UUID)" },
          {
            name: "role",
            label: "Rol",
            type: "select",
            options: [
              { value: "admin", label: "Admin" },
              { value: "moderator", label: "Moderator" },
              { value: "user", label: "İstifadəçi" },
            ],
          },
        ]}
        columns={[
          { name: "user_id", label: "İstifadəçi ID" },
          {
            name: "role",
            label: "Rol",
            render: (r) => ROLE_LABEL[String(r["role"])] ?? String(r["role"]),
          },
        ]}
      />
    </div>
  );
}
